/**
 * Copia in JavaScript del database. Serve solo per le tabelle dove vengono usate le form.
 * Bastano i campi mostrati nella form
 */
export default function () {
    return {
        prenotazione: {
            id: 0,
            data_controllo: '',
            ora_controllo: null,
            id_agricoltore: null,
            targa_unita_mobile: null,
            id_tecnico: null,
            compilato_in_convenzione: false,

            nazione: null,
            regione: null,
            provincia: null,
            comune: null,
            cap: null,
            frazione: null,
            via: null,
            numero_civico: null,

            note: ''
        },
        agricoltore: {
            id: 0,
            ragione_sociale: '',
            partita_iva: '',
            cuaa: '',
            id_convenzione: null,

            nazione: null,
            regione: null,
            provincia: null,
            comune: null,
            cap: null,
            frazione: null,
            via: null,
            numero_civico: null,

            nome_titolare: '',
            sesso: '',
            data_nascita: '',
            luogo_nascita: '',

            sdi: '0000000',
            pec: '',
            email: '',
            telefono: '',
            cellulare: '',

            note: []
        },
        convenzione: {
            id: 0,
            nome: '',
            telefono: '',

            nazione: null,
            regione: null,
            provincia: null,
            comune: null,
            cap: null,
            frazione: null,
            via: null,
            numero_civico: null
        },
        tecnico: {
            id: 0,
            nome: '',
            cognome: '',
            username: '',
            telefono: '',
            immagine_profilo: null
        },
        unitaMobile: {
            targa: null,
            descrizione: '',
            prodotti: []
        },
        avviso: {
            id: 0,
            colore: '',
            testo: '',
            data_avviso: null,
            ora_avviso: null
        }
    }
}
